import { createRef } from "react";
import { Modal } from "antd";
import BaseComponent from "../../../../base/common/BaseComponent";
import TlReviewProcedureSection from "../TlReviewProcedureSection";
import "../tlReview.scss";
import ProcedureDetailService from "service/procedureFile/ProcedureDetailService";
import { ControlPageBehavior } from "base/basicComponents/modal/controlPageBehavior";
const tlReviewProcedureSectionRef = createRef();
// @ts-ignore
const controlPageBehavior = new ControlPageBehavior();

class TlReviewProcedureModal extends BaseComponent {
  constructor(props: any) {
    super(props);
    this.state = { radioValue: null, submitDisabled: true };
  }

  showInputError = () => {
    // @ts-ignore
    tlReviewProcedureSectionRef.current.showInputError();
  };

  setDefault = () => {
    // @ts-ignore
    tlReviewProcedureSectionRef.current.setDefault();
  };

  updateFileNumLoading = () => {};

  refreshPage = () => {
    const para = {
      procedureId: this.props.procedureId,
      procedureSectionType: "TLReview",
      setLock: false,
    };
    ProcedureDetailService.setSectionLock(
      para,
      () => {
        window.location.reload();
      },
      (response: any) => {
        //empty function
      }
    );
  };

  componentDidUpdate(prevProps: any) {
    if (this.props.isModalOpen !== prevProps.isModalOpen) {
      if (this.props.isModalOpen) {
        const modalElement = document.querySelector('[data-target-id="review-info-modal"]');
        controlPageBehavior.addEleListener(modalElement);
        controlPageBehavior.resetListener(modalElement, this.refreshPage);
      } else {
        controlPageBehavior.clearListener();
      }
    }
  }

  render() {
    const { isModalOpen, onSubmit, onCancel, showLoading, hideLoading, zIndex } = this.props;

    return (
      <Modal
        title={null}
        centered
        open={isModalOpen}
        footer={null}
        closable={false}
        onCancel={onCancel}
        width="75rem"
        className="tlReviewModal"
        data-target-id="review-info-modal"
        data-testid="tl-review-procedure-modal"
        zIndex={zIndex}
        maskClosable={false}
      >
        {/* @ts-ignore */}
        <TlReviewProcedureSection
          ref={tlReviewProcedureSectionRef}
          onSubmit={onSubmit}
          onCancel={onCancel}
          showLoading={showLoading}
          hideLoading={hideLoading}
          isInModal={true}
        />
      </Modal>
    );
  }
}

export default TlReviewProcedureModal;
